import { useEffect, useState } from 'react'

import http from '../../shared/http'
import { TApi, TRoles } from '../../shared/const'

const MIT_KURSEN = [TRoles.STUDENT, TRoles.TEACHER]

/**
 * Soll der Menüpunkt „Kurse" erscheinen?
 *
 * Seit 01.11.2026 führt er zu den Kursen von TalentsLounge (`anbieter=TL`).
 * Schüler:innen sehen ihn, wenn die Kurse eingeschaltet sind und es für sie
 * mindestens einen gibt — ein Menüpunkt, hinter dem „keine Kurse" steht, wäre
 * ein Versprechen ohne Inhalt. Lehrkräfte sehen ihn immer: Dort stehen auch die
 * Angebote von TalentsLounge für ihre Klassen. Gefragt wird einmal je
 * Anmeldung und Rolle. Kennt der Server die Route noch nicht, bleibt der Punkt
 * still weg.
 */
export default function useCoursesMenu(role, isAuth) {
	const [sichtbar, setSichtbar] = useState(false)

	useEffect(() => {
		if (!isAuth || !MIT_KURSEN.includes(role)) {
			setSichtbar(false)
			return undefined
		}

		if (role === TRoles.TEACHER) {
			setSichtbar(true)
			return undefined
		}

		let aktiv = true
		http.get(TApi.TL_COURSES, { disableToast: true })
			.then(({ data }) => aktiv && setSichtbar(Boolean(data?.enabled) && (data?.courses || []).length > 0))
			.catch(() => aktiv && setSichtbar(false))

		return () => {
			aktiv = false
		}
	}, [role, isAuth])

	return sichtbar
}
